import { useEffect } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { useApplicationSize } from '@anwb/providers-application';
export default ({ useMasonry, gridRef }) => {
    const applicationSize = useApplicationSize();
    useEffect(() => {
        if (!useMasonry || !gridRef.current) {
            return () => { };
        }
        const gridElement = gridRef.current;
        const gridItemElements = [...gridRef.current.children];
        const resizeAllGridItems = () => {
            gridItemElements.forEach((_gridItem) => {
                var _a, _b;
                // assigning to new variable for eslint
                const gridItem = _gridItem;
                const itemHeight = (_b = (_a = (gridItem.firstElementChild || gridItem)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.height;
                gridItem.style.gridRowEnd =
                    applicationSize === 'small' ? '' : `span ${Math.ceil(itemHeight || 0)}`;
            });
            gridElement.style.gridAutoRows = applicationSize === 'small' ? '' : '1px';
            gridElement.style.opacity = applicationSize === 'small' ? '' : '1';
        };
        const resizeObserver = new ResizeObserver(() => resizeAllGridItems());
        gridItemElements.forEach((gridItem) => {
            const gridContentElement = (gridItem.children.length ? gridItem.firstChild : gridItem);
            if (gridContentElement) {
                resizeObserver.observe(gridContentElement);
            }
        });
        return () => {
            resizeObserver.disconnect();
        };
    }, [gridRef, useMasonry, applicationSize]);
};
//# sourceMappingURL=useMasonryLayout.js.map